import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Real Estate Agent",
    company: "Coldwell Banker",
    quote: "I set up my QCard in under a minute — for free. Now I look more professional than agents who pay $20/month for their digital cards.",
    avatar: "SM",
    industry: "Real Estate",
  },
  {
    name: "Marcus Chen",
    role: "Financial Advisor",
    company: "Morgan Stanley",
    quote: "Finally, a modern way to share my info. The follow-up after networking events is so much smoother now. Can't believe it's free.",
    avatar: "MC",
    industry: "Financial",
  },
  {
    name: "Jennifer Brooks",
    role: "Management Consultant",
    company: "Deloitte",
    quote: "My QCard looks polished and professional. Clients comment on it all the time. Best part? Setup took 60 seconds and cost nothing.",
    avatar: "JB",
    industry: "Consulting",
  },
];

const useCases = [
  {
    industry: "Real Estate",
    benefit: "Get more callbacks from leads",
    stat: "3x more follow-ups",
  },
  {
    industry: "Financial Services",
    benefit: "Build trust with your photo",
    stat: "45% better recall",
  },
  {
    industry: "Consulting",
    benefit: "Never be forgotten post-meeting",
    stat: "2x more referrals",
  },
  {
    industry: "Legal",
    benefit: "Instant professional credibility",
    stat: "60% faster onboarding",
  },
];

const TestimonialsSection = () => {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-semibold mb-4">
            Real Results
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6">
            Professionals Love{" "}
            <span className="text-gradient">How Easy It Is</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Join thousands who upgraded their professional presence — in 60 seconds, for free.
          </p>
        </div>

        {/* Testimonials */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-card rounded-3xl border border-border p-6 hover:border-primary/30 transition-all duration-300 hover:shadow-xl relative"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-primary/10" />
              
              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-primary text-primary" />
                ))}
              </div>
              
              {/* Quote */}
              <p className="text-foreground mb-6 leading-relaxed">"{testimonial.quote}"</p>
              
              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full gradient-primary flex items-center justify-center text-white font-bold">
                  {testimonial.avatar}
                </div>
                <div>
                  <p className="font-semibold text-foreground">{testimonial.name}</p>
                  <p className="text-sm text-muted-foreground">{testimonial.role}</p>
                  <p className="text-xs text-primary">{testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Use Cases Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {useCases.map((useCase, index) => (
            <div
              key={index}
              className="bg-muted/50 rounded-2xl p-6 text-center hover:bg-muted transition-colors"
            >
              <div className="inline-block px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-semibold mb-3">
                {useCase.industry}
              </div>
              <p className="text-foreground font-medium mb-2">{useCase.benefit}</p>
              <p className="text-2xl font-bold text-primary">{useCase.stat}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
